export default __webpack_public_path__ + "static/media/Javascript_Icon.166865da.png";